import React from 'react'
import * as PIXI from 'pixi.js-legacy'
import PropTypes from 'prop-types'

const angle90 = 1.5708
const POINT_RADIUS_BASE = 4
const minControlPointIndent = 100

export default class Arrow extends React.Component {
  static propTypes = {
    color: PropTypes.number,
    interactive: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onMouseOut: PropTypes.func,
    onMouseOver: PropTypes.func,
    onTap: PropTypes.func,
  }

  renderGraphics = (_x1, _y1, _x2, _y2, strokeWidth, arrowVisible) => {
    const $line = this.line
    $line.visible = arrowVisible

    if (!arrowVisible) {
      return
    }

    $line.clear()
    $line.position.set(_x1, _y1)

    const x1 = 0,
      y1 = 0,
      x2 = _x2 - _x1,
      y2 = _y2 - _y1

    const dx = x2 - x1
    const dy = y2 - y1
    const centerX = x1 + dx / 2
    const centerY = y1 + dy / 2

    const angle = Math.atan2(dy * -1, dx)
    const controlPointXDistance = Math.max(
      Math.abs(dx / 3),
      Math.abs(angle) > 1 ? minControlPointIndent : 0,
    )
    const cpx1 = x1 + controlPointXDistance,
      cpy1 = y1
    const cpx2 = x2 - controlPointXDistance,
      cpy2 = y2

    const { color, strokeOpacity } = this.props
    $line.lineStyle(strokeWidth, color, strokeOpacity)

    $line.moveTo(x1, y1)
    // Case for straight line from left to right
    if (dy === 0 && x1 < x2) {
      $line.lineTo(x2, y2)
    } else {
      $line.quadraticCurveTo(cpx1, cpy1, centerX, centerY)
      $line.moveTo(x2, y2)
      $line.quadraticCurveTo(cpx2, cpy2, centerX, centerY)
    }

    const arrowHeight = 10

    // Arrow ending
    if (!this.props.noEnding) {
      $line.beginFill(color)
      $line.moveTo(x2 - 1, y2)
      $line.lineTo(x2 - arrowHeight, y2 - (arrowHeight - 2))
      $line.lineTo(x2 - arrowHeight, y2 + (arrowHeight - 2))
      $line.lineTo(x2 - 1, y2)
      $line.endFill()
    }
    // if (!this.props.noEnding) {
    //   $line.moveTo(x2 - 1, y2)
    //   $line.lineTo(x2 - arrowHeight, y2 - (arrowHeight - 2))
    //   $line.moveTo(x2 - 1, y2)
    //   $line.lineTo(x2 - arrowHeight, y2 + (arrowHeight - 2))
    // }

    if (!$line.interactive) {
      return
    }

    const firstHitArea = getHitArea(x1, y1, cpx1, cpy1, centerX, centerY, strokeWidth)
    const secondHitArea = getHitArea(x2, y2, cpx2, cpy2, centerX, centerY, strokeWidth)
    const hitArea = [
      ...firstHitArea.forward,
      ...secondHitArea.back,
      ...secondHitArea.forward,
      ...firstHitArea.back,
    ]

    $line.hitArea = new PIXI.Polygon(hitArea)

    // const $poly = new PIXI.Graphics()
    // $poly.beginFill(0xFF00FF, .5)
    // $poly.drawPolygon(hitArea)
    // $poly.endFill()

    // ctx.addChild($poly)
  }

  handleGraphicsRef = (el) => {
    if (el) {
      this.line = el
    }
  }

  render() {
    const { interactive, name, onClick, onDoubleClick, onMouseOut, onMouseOver, onTap } = this.props
    return (
      <graphics
        ref={this.handleGraphicsRef}
        name={name}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        onMouseOut={onMouseOut}
        onMouseOver={onMouseOver}
        onTap={onTap}
        interactive={interactive}
      />
    )
  }
}

function lineDistance(x1, y1, x2, y2) {
  const dx = x2 - x1
  const dy = y2 - y1
  return Math.sqrt(dx * dx + dy * dy)
}

function getPt(n1, n2, perc) {
  const diff = n2 - n1
  return n1 + diff * perc
}

function getHitArea(x1, y1, cpx, cpy, x2, y2, lineWidth) {
  const forward = [],
    back = []
  const pointRadius = POINT_RADIUS_BASE * lineWidth

  const distance = lineDistance(x1, y1, cpx, cpy) + lineDistance(cpx, cpy, x2, y2)
  const pCount = Math.ceil((distance / pointRadius) * 2)
  const step = Math.max(0.02, 1 / pCount)

  for (let i = 0; i < 1; i += step) {
    // The Green Line
    const xa = getPt(x1, cpx, i)
    const ya = getPt(y1, cpy, i)
    const xb = getPt(cpx, x2, i)
    const yb = getPt(cpy, y2, i)

    const dx = xb - xa
    const dy = yb - ya

    // Invert the Y-axis for correct angle calculation (on the canvas it goes top to bottom)
    const angle = Math.atan2(dy * -1, dx)
    const angleForward = angle + angle90
    const angleBack = angle - angle90

    // The Black Dot
    const x = getPt(xa, xb, i)
    const y = getPt(ya, yb, i)

    const fPoint = new PIXI.Point(
      x + Math.cos(angleForward) * pointRadius,
      y - Math.sin(angleForward) * pointRadius,
    )
    const bPoint = new PIXI.Point(
      x + Math.cos(angleBack) * pointRadius,
      y - Math.sin(angleBack) * pointRadius,
    )

    forward.push(fPoint)
    back.unshift(bPoint)
  }

  return { forward, back }
}
